
@if (station.stationType === stationType.WORKING_AREA && station.stationUsage.transports.length == 0) {
  <app-station-tile class="station-item" styleClass="empty-working-station"
    [ngClass]="{'highlight': sacClientContext?.triggerHighlightNewTransports}" [height]="149"
    [isDisabled]="station.stationUsage.disabled"
    [suspended]="station.stationUsage.suspended || station.stationUsage.loadingZoneLock" [selected]="selected"
    >
    <app-empty-workingarea-item [station]="station" [selected]="selected">
    </app-empty-workingarea-item>
    <div class="hint">
      @if (station.stationUsage.faulty) {
        <div class="faulty-indicator"><i
        class="fa-light fa-triangle-exclamation"></i></div>
      }
      @if (station.stationUsage.transportsAvailable) {
        <div class="available-truck-indicator"><i
        class="fa-light fa-truck-container"></i></div>
      }
      <sc-content-spacer grow></sc-content-spacer>
      @if (station.stationUsage.suspended && selected) {
        <sc-icon iconClass="fa-lock-open" (click)="endSuspension()"
        ></sc-icon>
      }
      @if (!station.stationUsage.suspended && station.stationUsage.transports.length === 0 && !station.stationUsage.disabled && selected && !station.stationUsage.loadingZoneLock) {
        <sc-icon iconClass="fa-lock" (click)="startSuspension()"
        ></sc-icon>
      }
    </div>
  </app-station-tile>
}

@if (station.stationType === stationType.WORKING_AREA && station.stationUsage.transports.length == 1) {
  <app-station-tile class="station-item" styleClass="used-working-station"
    [ngClass]="{'highlight': sacClientContext?.triggerHighlightNewTransports}" [height]="149" [selected]="selected"
    >
    <app-used-workingarea-item [station]="station" [selected]="selected">
    </app-used-workingarea-item>
    <div class="hint">
      @if (station.stationUsage.faulty) {
        <div class="faulty-indicator"><i
        class="fa-light fa-triangle-exclamation"></i></div>
      }
      @if (station.stationUsage.plannedTransportAssignmentPossible && station.stationUsage.transportsAvailable) {
        <div class="available-truck-indicator"
          >
          <sc-icon iconClass="fa-truck-container"></sc-icon>
        </div>
      }
      <sc-content-spacer grow></sc-content-spacer>
      @if (station.stationUsage.suspended && selected) {
        <sc-icon iconClass="fa-lock-open" (click)="endSuspension()"
        ></sc-icon>
      }
      @if (!station.stationUsage.suspended && !station.stationUsage.disabled && selected) {
        <sc-icon iconClass="fa-lock" (click)="startSuspension()"
        ></sc-icon>
      }
    </div>
  </app-station-tile>
}

@if (station.stationType === stationType.WAITING_AREA) {
  <app-station-tile class="station-item" styleClass="waiting-area" [height]="149" [selected]="selected"
    >
    <app-waiting-area-item [station]="station" [selected]="selected">
    </app-waiting-area-item>
    <div class="hint">
      @if (station.stationUsage.faulty) {
        <div class="faulty-indicator"><i
        class="fa-light fa-triangle-exclamation"></i></div>
      }
      @if (station.stationUsage.transportsAvailable) {
        <div class="available-truck-indicator"
          >
          <sc-icon iconClass="fa-truck-container"></sc-icon>
        </div>
      }
    </div>
  </app-station-tile>
}
